// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_O8_","cls2":"Search-cls2_f4S Search-cls1_O8_"};